import graphql__b4134f49d79fec0b80a3 from "./__generated__/SubscriptionList_query.graphql.ts";import * as React from "react"
import {useEffect, useTransition} from "react"
import {graphql} from "react-relay";
import {usePaginationFragment} from "react-relay/hooks";
import LoadMoreButton from "./presentational/LoadMoreButton";
import SubscriptionListItem from "./SubscriptionListItem";
import {useIntl} from "react-intl";

type Props = {
    queryRef: any // FIXME: Any type we can define here? It's actually: Readonly<{ ' $data'?: unknown; ' $fragmentRefs': unknown; }> | null
    searchTerm?: string
    onLoadingChange?: (isLoading: boolean) => void
}

type SubscriptionListProps = Props;

const SubscriptionList: React.FC<SubscriptionListProps> = (props) => {
    const intl = useIntl();
    const [isPending, startTransition] = useTransition();
    const {data, hasNext, loadNext, isLoadingNext, refetch} = usePaginationFragment(
        graphql__b4134f49d79fec0b80a3,
        props.queryRef
    );

    useEffect(() => {
        // Use startTransition to keep the old data visible while loading new data
        // This prevents the Suspense fallback from showing
        startTransition(() => {
            refetch({searchTerm: props.searchTerm}, {fetchPolicy: 'store-and-network'});
        });
    }, [props.searchTerm, refetch])

    useEffect(() => {
        // Notify parent component about loading state
        props.onLoadingChange?.(isPending);
    }, [isPending, props]);

    if (!data.subscriptions || data.subscriptions.totalCount === 0) {
        return (<></>);
    }

    return (
        <nav className="flex-1 min-h-0 relative overflow-y-auto" aria-label={intl.formatMessage({id: 'navigation.subscriptions'})}>
            <ul className="relative z-0 divide-y divide-gray-200">
                {data.subscriptions.edges.map(
                    (edge, index) => {
                        return <SubscriptionListItem key={index} subscription={edge.node}/>
                    }
                )}
            </ul>
            {hasNext && <LoadMoreButton onClick={() => loadNext(100)} isLoadingNext={isLoadingNext}/>}
        </nav>
    )
}

export default SubscriptionList;
